const importEngine = {
  title: "Import Engine",
  description: "Import CSV/Excel files into the entity system",
  uploadFile: "Upload File",
  dragDrop: "Drag & drop a file here",
  orClickBrowse: "or click to browse",
  supportedFormats: "Supported formats: CSV, XLSX, XLS",
  maxFileSize: "Max 5MB",
  maxRows: "Max 5,000 rows",
  selectEntityType: "Select Entity Type",
  columnMapping: "Column Mapping",
  autoDetect: "Auto-detect",
  autoDetectAll: "Auto-detect All",
  sourceColumn: "Source Column",
  targetField: "Target Field",
  detectedType: "Detected Type",
  confidence: "Confidence",
  skip: "Skip",
  preview: "Preview",
  previewDescription: "Showing first 10 rows",
  validRows: "valid rows",
  invalidRows: "invalid rows",
  skippedColumns: "skipped columns",
  errorRate: "Error rate",
  errorRateWarning: "Error rate too high (max 10%)",
  importing: "Importing",
  importComplete: "Import Complete",
  importFailed: "Import Failed",
  importProgress: "Progress",
  rowsImported: "rows imported",
  rowsFailed: "rows failed",
  errors: "Errors",
  back: "Back",
  next: "Next",
  startImport: "Start Import",
  importHistory: "Import History",
  fileName: "File Name",
  entityType: "Entity Type",
  date: "Date",
  status: "Status",
  statusPending: "Pending",
  statusProcessing: "Processing",
  statusCompleted: "Completed",
  statusFailed: "Failed",
  noImports: "No imports yet",
  viewErrors: "View Errors",
  downloadErrors: "Download Errors",
} as const;
export default importEngine;
